import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, Outlet } from 'react-router-dom';
import { trackPageView } from '../../redux/analytics/analytics.reducer';
import { rememberCampaign, safeAnalyticsUrl } from '../../libs/helpers/analytics';
import { resolveAnalyticsPageTitle } from './routeTitles';

export const AnalyticsRouteTracker = () => {
    const { pathname, search } = useLocation();
    const dispatch = useDispatch();
    const previousPage = useRef(null);
    const currentSearch = useRef(search);
    currentSearch.current = search;

    useEffect(() => {
        rememberCampaign(search);
    }, [search]);

    useEffect(() => {
        // Removing download=1 or changing a local filter is not a new page.
        if (previousPage.current?.path === pathname) return;
        const arrivalSearch = currentSearch.current;
        let active = true;
        const sendPageView = (title) => {
            if (!active || previousPage.current?.path === pathname) return;
            const referrer = previousPage.current?.url || document.referrer;
            previousPage.current = {
                path: pathname,
                url: safeAnalyticsUrl(`${window.location.origin}${pathname}${arrivalSearch}`),
            };
            dispatch(trackPageView({ path: pathname, search: arrivalSearch, referrer, title }));
        };
        const title = resolveAnalyticsPageTitle(pathname);
        if (typeof title === 'string') {
            sendPageView(title);
        } else {
            title.then(sendPageView).catch(() => sendPageView('PrepBox Blog'));
        }
        return () => { active = false; };
    }, [dispatch, pathname]);

    return null;
};

const AnalyticsRouteBoundary = () => (
    <>
        <Outlet />
        <AnalyticsRouteTracker />
    </>
);

export default AnalyticsRouteBoundary;
